<template>
	<div class="MixinCell">
		<div class="shops">
			<div class="shop flex">
				<div style="flex-shrink: 0" class="mt-4">
					<img class="img" :src="row['product_pic']" alt="" />
				</div>
				<div class="ml-10 align-left shop-right yx-color-text-primary">
					<p class="link flex-row-align-center">
						<platform-icon :platformId="row['platform_id']"></platform-icon>
						<el-tooltip v-ak-tooltip-auto-show :content="row['product_name']" placement="top-start" effect="dark">
							<span class="ml-4 skip-link line-ellipsis-1 cursor-pointer flex-1" @click="skipFun">{{ row['product_name'] }}</span>
						</el-tooltip>
						<!-- hideCopyLink 视频号 项目时新增了一个 复制商品链接的功能（UI优化） 但是订单板块没有商品链接 并且这里原本也没有复制功能， 所以新增了一个快关 默认开启 可以隐藏 -->
						<el-tooltip v-if="$isPlatOr(row.platform_id, ['Dy','Sp']) && !row.hideCopyLink" placement="top" :content="content" :disabled="!content">
							<div class="tag radius-4 ml-4 font-h6-regular yx-color-text-regular cursor-pointer hover" @click="copyLink()">
								<i class="el-icon-link"></i>
							</div>
						</el-tooltip>
						<ID-tag label="商品ID" :id="row.third_product_id" />
					</p>
					<p class="yx-color-text-regular ellipsis"></p>
						<span>ID：</span>
						<span class="third-id">{{ row['third_product_id'] }}</span>
					</p>
					<p class="yx-color-text-regular fz-12">
						<el-tooltip v-if="column.showProductType && productTagInfo.tooltip" :content="productTagInfo.tooltip" placement="top">
							<span class="product-tag mr-6" :class="productTagInfo.className">{{ row.product_type_name }}</span>
						</el-tooltip>
						<span class="team_pro mr-6" v-if="!column.showProductType && row['source_type'] === '2'">团长商品</span>
						<span class="brand-name pr-4 pl-4 pt-2 pb-2" v-if="row['brand_name']">{{ row['brand_name'] }}</span>
						<span class="ml-6 cate_name pr-4 pl-4 pt-2 pb-2" v-if="row['cate_name']">{{ row['cate_name'] }}</span>
						<div v-if="column.commissionType">
							<span v-if="+row.commission_type === 0" class="seller-commission">商家指定佣金</span>
							<span v-if="+row.commission_type === 1" class="institution-commission">机构分配佣金</span>
						</div>
					</p>
					<div class="font-h6-regular yx-color-text-p-4 flex flex-align-center">
						<p class="flex-row-align-center">
							<span>店铺：</span>
							<el-tooltip placement="top" :content="row['shop_name']" v-ak-tooltip-auto-show>
								<span class="line-ellipsis-1" style="max-width: 50px">{{ row['shop_name'] }}</span>
							</el-tooltip>
							<ID-tag label="店铺ID" :id="row.shop_id" />
						</p>
						<shop-score
							:apiParam="{ shopId: row.shop_id, platformId: row.platform_id, thirdProductId: row.third_product_id }"
							:shopName="row['shop_name']"
							v-if="$isDy(row.platform_id) && column.source !== 'order'"
						>
							<template v-slot:popover="{ shopScores }">
								<span class="ml-4 cursor-pointer font-h6-regular">
									体验分
									<span class="font-bold yx-color-pure-1 ml-4">
										{{
											shopScores.shopScore ? shopScores.shopScore : row.shop_scores && row.shop_scores.shop_score ? row.shop_scores.shop_score : '-'
										}}
									</span>
									<i class="el-icon-arrow-right"></i>
								</span>
							</template>
						</shop-score>
						<div class="font-h6-regular yx-color-text-p-4 ml-4" v-if="($isKs(row.platform_id) || $isSp(row.platform_id)) && column.source !== 'order'">
							体验分:
							<span class="font-bold yx-color-pure-1 ml-4">{{ shopScore | formatEmpty }}</span>
						</div>
					</div>
					<p v-if="calcOrderId">
						<span class="yx-color-text-regular">订单ID：</span>
						<span>{{ calcOrderId }}</span>
					</p>
				</div>
			</div>
			<p class="tips mt-10" v-if="0">
				<i class="el-icon-warning"></i>
				<span class="fz-14 ml-4">商品信息采集链接失效，已停止更新商品基础信息</span>
			</p>
		</div>
	</div>
</template>

<script>
import shopScore from '@/components/shopScore';
import { copyFun } from '@/utils/common';
import { zsRoleType } from '@/utils/dataMap';
import { getSourceUrl } from '@/api/shopManage';
import { mapGetters } from 'vuex';
import mixin from './mixin';
import IDTag from '@/components/ui/IDTag';
import dataMap from '../../utils/dataMap';
export default {
	name: 'MixinCell',
	components: {
		shopScore,
		IDTag,
	},
	mixins: [mixin],
	computed: {
		calcOrderId() {
			const orderIdMap = {
				[dataMap.PLATFORM_DY.value]: 'order_id',
				[dataMap.PLATFORM_KS.value]: 'order_id',
				[dataMap.PLATFORM_SP.value]: 'parentOrderId',
			};
			return this.row[orderIdMap[this.row.platform_id]];
		},
		cellValue() {
			const val = this.row[this.column.key];
			if (typeof val === 'object') {
				return val;
			}
			return '';
		},
		...mapGetters(['isDarenPartner']),
		productTagInfo() {
			const arr = [
				'',
				{ tooltip: `来源于团队“${zsRoleType.name}”角色，手动上传的商品`, className: 'one' },
				{ tooltip: '来源于商家，且未报名其他团长招商活动的商品', className: 'two' },
				{ tooltip: '来源于商家，且成功报名了其他团长招商活动的商品', className: 'three' },
				{ tooltip: '来源于其他团长的商品', className: 'four' },
				{ tooltip: '来源于商家，报名托管的商品', className: 'two' },
			];
			const { row: { product_type = '' } = {} } = this;
			return arr[product_type] || {};
		},
		shopScore({ row }) {
			return row?.shop_scores?.shop_score || '';
		},
		content() {
			if (this.$isSp(this.row.platform_id)) {
				return '';
			}
			// 保持不变
			return this.isDarenPartner
				? this.row.source_type === '2' || this.row.product_type != 1
					? '专属链接，达人使用该链接带货产生的订单归属为您的业绩。'
					: '该链接非团长商品链接，达人使用该链接(托管商品链接除外)带货产生的订单无法统计到团队业绩。'
				: `非专属链接，达人使用该链接带货产生的订单无法归属到${this.drName}。请前往${this.drName}账号复制专属链接。`;
		},
	},
	methods: {
		click(item) {
			if (item.click) {
				item.click(this.row, this.rowIndex);
			}
		},
		async skipFun() {
			if (this.$isSp(this.row.platform_id)) {
				return;
			}
			const {
				isDarenPartner,
				row: { product_id, cooperate_id, product_url, order_id },
				handLink,
			} = this;
			// 保持不变
			// 没有订单ID并且是达人运营才进行转链
			if (isDarenPartner && product_id && !order_id) {
				const { code, data } = await getSourceUrl({ product_id, cooperate_id });
				if (code === 0) {
					let link = data.pick_source;
					handLink(link);
				}
			} else {
				handLink(product_url);
			}
		},
		copyLink() {
			copyFun(this.row, this, '1');
		},
		handLink(link) {
			var a = document.createElement('a');
			a.setAttribute('href', link);
			a.setAttribute('target', '_blank');
			a.setAttribute('id', 'startTelMedicine');
			// 防止反复添加
			if (document.getElementById('startTelMedicine')) {
				document.body.removeChild(document.getElementById('startTelMedicine'));
			}
			document.body.appendChild(a);
			a.click();
		},
	},
};
</script>

<style lang="less" scoped>
.fixed-right {
	text-align: right;
	padding: 4px 0;
	.el-button:not(:first-child) {
		margin-top: 4px;
	}
}
.default {
	color: #000000;
	border-bottom: 1px solid transparent;
}

.default:hover {
	cursor: pointer;
	border-bottom: 1px solid rgb(51, 51, 51);
}

.notSelf {
	color: #ddd;
}
.notSelf:hover {
	cursor: default;
	border-bottom: none;
}
.img {
	width: 64px;
	height: 64px;
}
.shop-right {
	width: 280px;
}
.third-id {
	white-space: nowrap;
}
.brand-name {
	color: #ae6c41;
	background-color: #fff2e9;
	border-radius: 2px;
	font-weight: 500;
}
.cate_name {
	background-color: #f8f8f8;
	color: #666666;
}
.tips {
	color: #fa2d48;
}
.team_pro {
	border-radius: 2px;
	padding: 2px 4px;
	text-align: center;
	width: 60px;
	background-color: #ebf2fd;
	color: @color-primary;
}
.skip-link {
	cursor: pointer;
	color: #333;
}
.skip-link:hover {
	color: @color-primary;
}
.product-tag {
	display: inline-block;
	height: 18px;
	line-height: 18px;
	padding: 0 4px;
	border-radius: 2px;
	font-size: 12px;
	&.one {
		color: #0c9f1b;
		background-color: #ecf4ed;
	}
	&.two {
		color: @color-primary;
		background-color: #ebf2fd;
	}
	&.three {
		color: #c87210;
		background-color: #fef3e7;
	}
	&.four {
		color: #333333;
		background-color: #f5f5f5;
	}
}
.seller-commission {
	padding: 1px 4px 1px 4px;
	border-radius: 3px;
	box-sizing: border-box;
	border: 1px solid #fdcdc5;
	text-align: center;
	color: #f53f3f;
	font-size: 10px;
	background: #ffece8;
}
.institution-commission {
	padding: 1px 4px 1px 4px;
	border-radius: 3px;
	box-sizing: border-box;
	border: 1px solid #aff0b5;
	text-align: center;
	color: #00b42a;
	font-size: 10px;
	background: #e8ffea;
}
</style>
